import { render } from "./InvoicesTable.vue?vue&type=template&id=03063c20&scoped=true"
import script from "./InvoicesTable.vue?vue&type=script&lang=js"
export * from "./InvoicesTable.vue?vue&type=script&lang=js"

import "./InvoicesTable.vue?vue&type=style&index=0&id=03063c20&scoped=true&lang=scss"
import "./InvoicesTable.vue?vue&type=style&index=1&id=03063c20&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03063c20"]])

export default __exports__